import { InternalPageColumns as columns } from '../columnsConfig';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import AgGridSkeleton from '@/app/common/components/skeleton/AgGridSkeleton';
import ApiLoadError from '@/components/errors/ApiLoadError';
import {
  useGetInternalPagesCountQuery,
  useGetInternalPagesChartStatsQuery,
  useGetInternalPagesMutation
} from '../api/backlinkInternalPage';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useExportBacklinkTableMutation } from '../api/exportApi';
import FiltersComponent from '@/app/common/components/filters/FiltersComponent';
import InternalPageCharts from '../components/InternalPageCharts';
import useBacklinkQueryBody, {
  toOverviewQueryBody
} from '../hooks/useBacklinkQueryBody';


const InternalPage = () => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const [exportTable] = useExportBacklinkTableMutation();
  const body = useBacklinkQueryBody();
  const chartBody = toOverviewQueryBody(body);
  const {
    data: getInternalPageRes,
    isFetching: getInternalPageLoading,
    isError: getInternalPageError,
    error: getInternalPageErrorDetails,
    refetch: refetchInternalPage
  } = useGetInternalPagesCountQuery({ ...body, page: 1, perPage: 50 });
  const {
    data: internalPageChartRes,
    isFetching: internalPageChartLoading,
    isError: internalPageChartError,
    error: internalPageChartErrorDetails,
    refetch: refetchInternalPageChart
  } = useGetInternalPagesChartStatsQuery(chartBody);
  const [
    getInternalPageFunc,
    {
      isError: isInternalPageMutationError,
      error: internalPageMutationError,
      isLoading: isInternalPageMutationLoading,
      reset: resetInternalPageMutation
    }
  ] = useGetInternalPagesMutation();
  return (
    <div>
      <FiltersComponent
        preQueries={searchParams.toString()}
        columns={columns}
      />
      {internalPageChartLoading ? (
        <AgGridSkeleton height="300px" />
      ) : internalPageChartError ? (
        <ApiLoadError
          error={internalPageChartErrorDetails}
          isError={internalPageChartError}
          onRetry={() => refetchInternalPageChart?.()}
          isRetrying={internalPageChartLoading}
          className="mb-3"
        />
      ) : (
        <InternalPageCharts data={internalPageChartRes?.data} />
      )}
      {!getInternalPageLoading ? (
        getInternalPageError ? (
          <ApiLoadError
            error={getInternalPageErrorDetails}
            isError={getInternalPageError}
            onRetry={() => refetchInternalPage?.()}
            isRetrying={getInternalPageLoading}
          />
        ) : isInternalPageMutationError ? (
          <ApiLoadError
            error={internalPageMutationError}
            isError={isInternalPageMutationError}
            onRetry={() => {
              resetInternalPageMutation?.();
              refetchInternalPage?.();
            }}
            isRetrying={isInternalPageMutationLoading}
          />
        ) : (
          <AgGridWrapper
            table_name={pathname.split('/').slice(1, 3).join('/')}
            otherOptions={{
              rowHeight: 78,
              headerHeight: 52
            }}
            settings={{
              pagination: true,
              fullscreen: false,
              changeHeight: false,
              resetGrid: false,
              saveGrid: false,
              sideBar: false,
              export: {
                enabled: true,
                fetchFunction: exportTable,
                additionalData: body
              }
            }}
            stickyHorizontalScroll
            stickyHeader
            height="auto"
            fetchFunction={getInternalPageFunc}
            total={getInternalPageRes?.data?.total}
            data={getInternalPageRes?.data?.rows}
            columns={columns}
            additionalData={body}
          />
        )
      ) : (
        <AgGridSkeleton height="400px" />
      )}
    </div>
  );
};

export default InternalPage;
